import React, { useState, useRef } from 'react'

function FileUploadArea({ onFileSelected }) {
    const [isDragging, setIsDragging] = useState(false)
    const fileInputRef = useRef(null)
    const dropAreaRef = useRef(null)

    const handleFileChange = (e) => {
        const file = e.target.files[0]
        if (file) {
            onFileSelected(file)
        }
    }

    const handleDragEnter = (e) => {
        e.preventDefault()
        e.stopPropagation()
        setIsDragging(true)
    }

    const handleDragOver = (e) => {
        e.preventDefault()
        e.stopPropagation()
        if (!isDragging) setIsDragging(true)
    }

    const handleDragLeave = (e) => {
        e.preventDefault()
        e.stopPropagation()

        if (dropAreaRef.current && !dropAreaRef.current.contains(e.relatedTarget)) {
            setIsDragging(false)
        }
    }

    const handleDrop = (e) => {
        e.preventDefault()
        e.stopPropagation()
        setIsDragging(false)

        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            const file = e.dataTransfer.files[0]
            const fileExtension = file.name.split('.').pop().toLowerCase()

            if (['xlsx', 'xls'].includes(fileExtension)) {
                onFileSelected(file)
            } else {
                // This error will be handled in the parent component
                throw new Error('Please upload only Excel files (.xlsx, .xls)')
            }
        }
    }

    const handleButtonClick = () => {
        fileInputRef.current.click()
    }

    return (
        <div
            ref={dropAreaRef}
            className={`border-2 border-dashed rounded-lg p-10 text-center mb-6 transition-colors duration-200
        ${isDragging ? 'border-blue-500 bg-blue-50' : 'border-gray-300 bg-gray-50'}`}
            onDragEnter={handleDragEnter}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
        >
            <div className="flex flex-col items-center justify-center">
                <svg className="w-10 h-10 text-gray-400 mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                </svg>
                <p className="mb-2 text-sm font-semibold text-gray-700">Drag and drop your Excel file here, or</p>
                <button
                    type="button"
                    onClick={handleButtonClick}
                    className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                >
                    Select file
                </button>
                <input ref={fileInputRef} type="file" className="hidden" accept=".xlsx,.xls" onChange={handleFileChange} />
                <p className="mt-2 text-xs text-gray-500">Accepted file types: .xlsx, .xls</p>
            </div>
        </div>
    )
}

export default FileUploadArea
